module.exports = __webpack_public_path__ + "static/media/logo.a63179a1.png";